import PropTypes from 'prop-types';
import React from 'react';
import { isArray, sortBy, isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, Modal, ModalService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import { ModelYear } from '@sm360/widget-commons-vehicle';

import FeatureBlock from 'build-and-quote/components/Summary/components/VehicleCharacteristics/components/FeatureBlock.jsx';

import 'build-and-quote/components/Summary/components/VehicleCharacteristics/VehicleCharacteristics.scss';

const MODAL = 'widget/SummarySection';
const STYLES = {
    overlay: {
        zIndex: 2147483643,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        background: '#fff',
        overflowY: 'auto',
    },
};

class VehicleCharacteristics extends React.Component {
    constructor(props) {
        super(props);

        this.modal = ModalService.get(MODAL);
        this.renderFeatures = this.renderFeatures.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.getFeatureIcons = this.getFeatureIcons.bind(this);
    }

    onOpenModal() {
        AnalyticsService.gaTrigger(TAGS.SPECS_SEE_ALL(this.props.selectedModel.model));
        this.modal.open();
    }

    getFeatureIcons(modelTrim) {
        if (!modelTrim || modelTrim.length === 0) {
            return null;
        }

        const featureIcons = Array.from(modelTrim.get('comparisonAddFeatureIcons')) || [];
        return sortBy(featureIcons, (rankIcon) => rankIcon.get('rank'));
    }

    renderFeatures(modelTrimFeatures) {
        if (!modelTrimFeatures && isEmpty(modelTrimFeatures)) {
            return null;
        }
        return Object.values(modelTrimFeatures.features).map((feature) => {
            return (
                <li className="features-bloc">
                    <div className="features-bloc--content">{feature.description}</div>
                </li>
            );
        });
    }

    render() {
        const {
            featureIcons,
            isDoubleColumnLayout,
            isDisplaying,
            selectedModel,
            modelTrimFeatures,
            selectedPackage,
        } = this.props;

        const optionalFeatures = featureIcons.filter((feature) => !feature.get('isFromModelTrim')).slice(0, 10);

        const blockClasses = ['car-features'];
        if (isDoubleColumnLayout) {
            blockClasses.push('is-double');
        }

        const featureIconList = this.getFeatureIcons(modelTrimFeatures);
        const featureIconShortList = isArray(featureIconList) && featureIconList.slice(0, 11);

        return (
            isDisplaying &&
            selectedModel && (
                <div className={blockClasses.join(' ')}>
                    <h2 className="features-title sr-subtitle-2">{LocaleService.t('summarySection.features_title')}</h2>

                    {selectedPackage && <FeatureBlock features={optionalFeatures} packageName={selectedPackage} />}
                    {featureIconShortList.length > 0 ? (
                        <div>
                            <FeatureBlock
                                features={featureIconShortList}
                                packageName={modelTrimFeatures.getDescription()}
                            />
                            <button className="sr-link" onClick={this.onOpenModal}>
                                {LocaleService.t('summarySection.seeAllFeatures')}
                            </button>
                        </div>
                    ) : (
                        '-'
                    )}

                    <Modal name={MODAL} contentLabel="features section dialog" style={STYLES}>
                        <div className="style-specs__modal-close-bloc">
                            <button className="modal-close icon-showroom" onClick={this.modal.close} />
                        </div>
                        <div className="style-specs__modal car-equipments_summary is-scrollable">
                            <ul className="car-equipments_summary-list"> {this.renderFeatures(modelTrimFeatures)} </ul>
                        </div>
                    </Modal>
                </div>
            )
        );
    }
}

VehicleCharacteristics.defaultProps = {
    isDisplaying: false,
    selectedModel: [],
    isDoubleColumnLayout: false,
};

VehicleCharacteristics.propTypes = {
    modelTrimFeatures: PropTypes.instanceOf(ModelYear.ModelTrimModel),
    featureIcons: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.FeatureIcon)).isRequired,
    isDisplaying: PropTypes.bool,
    isDoubleColumnLayout: PropTypes.bool,
    selectedModel: PropTypes.shape({
        year: PropTypes.number.isRequired,
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
    }),
    selectedPackage: PropTypes.string.isRequired,
};

VehicleCharacteristics.displayName = 'VehicleCharacteristics';

export default VehicleCharacteristics;
